/**
 * Environmental Impact Domain Models
 * Defines types and interfaces for Family Environmental Impact KPIs
 */
/**
 * KPI Type enumeration
 * Represents the different types of environmental impact metrics
 */
export var KpiType;
(function (KpiType) {
    KpiType["WATER"] = "WATER";
    KpiType["CO2"] = "CO2";
    KpiType["ANIMALS_SAVED"] = "ANIMALS_SAVED";
    KpiType["FOREST_PROTECTED"] = "FOREST_PROTECTED";
    KpiType["GRAIN"] = "GRAIN";
})(KpiType || (KpiType = {}));
